module.exports = __webpack_public_path__ + "img/open-new-tab-icon.c3328e08.svg";